import { Pipe, PipeTransform } from "@angular/core";
import { formatDisplayCurrencyAmount } from "@core/currency-display.util";

/**
 * Display currency amounts: whole values without trailing .00,
 * fractional values with two decimals (e.g. 10 -> "10", 4.5 -> "4.50").
 */
@Pipe({
  name: "displayCurrency",
  standalone: true,
})
export class DisplayCurrencyPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    return formatDisplayCurrencyAmount(value);
  }
}
